import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getCategory = createAsyncThunk(
  "categorySlice/getCategory",
  async (data) => {
    return await fetch("https://api.mobrespos.com/get_image", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((datax) => {
        const newArr = datax.map((v, index) => ({ ...v, id: index }));

        return newArr;
      });
  }
);

const initialState = {
  status: null,

  data: [],
};

const categorySlice = createSlice({
  name: "categorySlice",
  initialState,
  extraReducers: {
    [getCategory.pending]: (state) => {
      state.status = true;
    },

    [getCategory.fulfilled]: (state, action) => {
      state.status = false;
      state.data = action.payload;
    },

    [getCategory.rejected]: (state) => {
      state.status = false;
    },
  },
});

export default categorySlice.reducer;
